export default "__VITE_ASSET__Bcymg_dp__"